import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function queryInboundApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.queryinboundapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/entryOrder/query"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/gateway/edi/entryOrder/query"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/entryOrder/query"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value:
              "https://openapi.jtfulfillment.cn/gateway/edi/entryOrder/query"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.customeridDesc122"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc123"
            },
            {
              name: "entryOrderCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.entryOrderCodeDesc124"
            },
            {
              name: "wmsOrderCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.wmsOrderCodeDesc125"
            },
            {
              name: "returnWaybillCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.wmsOrderCodeDesc1255"
            },
            {
              name: "command",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.commandDesc126"
            },
            {
              name: "startdate",
              type: "DATE",
              require: "N",
              normal: "",
              describe: "apiDocDesc.startdateDesc127"
            },
            {
              name: "enddate",
              type: "DATE",
              require: "N",
              normal: "",
              describe: "apiDocDesc.enddateDesc128"
            },
            {
              name: "batches",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.batchesDesc129"
            },
            {
              name: "ordertype",
              type: "INT",
              require: "N",
              normal: "",
              describe: "apiDocDesc.ordertypeDesc130"
            },
            {
              name: "status",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.statusDesc131"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc132"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.reasonDesc133"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.warehouseCodeDesc134"
            },
            {
              name: "orderType",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.orderTypeDesc135"
            },
            {
              name: "orderTypeCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.orderTypeCodeDesc136"
            },
            {
              name: "entryOrderCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.entryOrderCodeDesc137"
            },
            {
              name: "wmsOrderCode",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.wmsOrderCodeDesc138"
            },
            {
              name: "returnWaybillCode",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.entryOrderIdDesc1641"
            },
            {
              name: "expectStartTime",
              type: "DATE",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.expectStartTimeDesc139"
            },
            {
              name: "created",
              type: "DATETIME",
              require: "N",
              normal: "",
              describe: "apiDocDesc.createdDesc140"
            },
            {
              name: "closedAt",
              type: "DATETIME",
              require: "N",
              normal: "",
              describe: "apiDocDesc.closedAtDesc141"
            },
            {
              name: "remark",
              type: "VARCHAR",
              require: "N",
              normal: "",
              describe: "apiDocDesc.remarkDesc142"
            },
            {
              name: "status",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.statusDesc143"
            },
            {
              name: "items",
              type: "",
              require: "",
              normal: "",
              describe: "apiDocDesc.itemsDesc144",
              children: [
                {
                  name: "LineNo",
                  type: "",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.LineNoDesc145"
                },
                {
                  name: "itemCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemCodeDesc146"
                },
                {
                  name: "itemName",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.itemNameDesc147"
                },
                {
                  name: "shortName",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.shortNameDesc148"
                },
                {
                  name: "unit",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.unitDesc149"
                },
                {
                  name: "quantity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.quantityDesc150"
                },
                {
                  name: "actualQty",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.actualQtyDesc151"
                },
                {
                  name: "snList",
                  type: "Array",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.reserved1Desc1841",
                  children: [
                    {
                      name: "sn",
                      type: "String[]",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.reserved1Desc18411"
                    }
                  ]
                },
                {
                  name: "batches",
                  type: "",
                  require: "",
                  normal: "",
                  describe: "apiDocDesc.batchesDesc152",
                  children: [
                    {
                      name: "actualQty",
                      type: "INT",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.actualQtyDesc153"
                    },
                    {
                      name: "inventoryType",
                      type: "varchar(50)",
                      require: "Y",
                      normal: "",
                      describe: "apiDocDesc.inventoryTypeDesc154"
                    },
                    {
                      name: "productDate",
                      type: "date",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.productDateDesc155"
                    },
                    {
                      name: "expireDate",
                      type: "date",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.expireDateDesc156"
                    },
                    {
                      name: "produceCode",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.produceCodeDesc157"
                    },
                    {
                      name: "batchCode",
                      type: "varchar(50)",
                      require: "N",
                      normal: "",
                      describe: "apiDocDesc.batchCodeDesc158"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        customerid: "DEV-TEST",
        command: "1",
        batches: 1,
        warehouseCode: "SH.001",
        entryOrderCode: "20240619211526577",
        ordertype: 1
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "3daa4f3217188548855523833e",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            orderList: [
              {
                orderType: "2",
                orderTypeCode: "",
                entryOrderCode: "20240619211526577",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:26",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                closedAt: "2024-06-19T21:18:06",
                items: [
                  {
                    quantity: "4",
                    itemCode: "Test001",
                    actualQty: "4",
                    itemName: "test001",
                    unit: "个",
                    snList: {
                      sn: ["1111", "jian1", "jian4", "xhhdhhdd"]
                    }
                  }
                ],
                status: "6",
                returnWaybillCode: "ktyd20260225111809584"
              },
              {
                orderType: "5",
                orderTypeCode: "THRK",
                entryOrderCode: "20240619211522867",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:23",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "5",
                    batches: [
                      {
                        inventoryType: "ZP",
                        actualQty: 5,
                        productDate: "",
                        expireDate: ""
                      }
                    ],
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "4"
              },
              {
                orderType: "",
                orderTypeCode: "QTRK",
                entryOrderCode: "20240619211518453",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:18",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "0",
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "2"
              },
              {
                orderType: "",
                orderTypeCode: "DBRK",
                entryOrderCode: "20240619211516995",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:17",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "0",
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "2"
              },
              {
                orderType: "3",
                orderTypeCode: "",
                entryOrderCode: "20240619211521380",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:21",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "5",
                    batches: [
                      {
                        inventoryType: "ZP",
                        actualQty: 5,
                        productDate: "",
                        expireDate: ""
                      }
                    ],
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "4"
              },
              {
                orderType: "4",
                orderTypeCode: "CGRK",
                entryOrderCode: "20240619211453153",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:14:53",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "0",
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "2"
              },
              {
                orderType: "2",
                orderTypeCode: "",
                entryOrderCode: "20240619211525133",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:25",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "1",
                    batches: [
                      {
                        inventoryType: "ZP",
                        batchCode: "",
                        actualQty: 1,
                        productDate: "",
                        produceCode: "",
                        expireDate: ""
                      }
                    ],
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "2"
              },
              {
                orderType: "3",
                orderTypeCode: "",
                entryOrderCode: "20240619211519883",
                expectStartTime: "2019-01-01",
                created: "2024-06-19T21:15:20",
                remark: "",
                warehouseCode: "SH.001",
                customerid: "DEV-TEST",
                erpOrderCode: "",
                closedAt: "2024-06-19T21:20:29",
                items: [
                  {
                    quantity: "5",
                    itemCode: "Test001",
                    actualQty: "5",
                    batches: [
                      {
                        inventoryType: "ZP",
                        actualQty: 5,
                        productDate: "",
                        expireDate: ""
                      }
                    ],
                    itemName: "test001",
                    unit: "个"
                  }
                ],
                status: "5"
              }
            ],
            entryOrderCode: null,
            entryOrderId: null
          }
        ]
      }
    }
  };
}
